/**
 * The home page: what this is, who makes it, and where to go next.
 *
 * It used to be the whole site — ten bands of figures and evidence, ending in a
 * link to a repository. Everything in it was true and most of it was for a
 * reader who had already decided. A person who arrives at kimene.tr knowing
 * nothing needs four screens, not forty: the sentence, the shape, one look at
 * the real thing, and the company's name.
 *
 * Nothing was deleted to achieve that. The seven capability bands are the
 * product page and the two trust bands are the security page, whole, with the
 * evidence they always carried — and this page links into them rather than
 * summarising them, so no claim exists in two places to be corrected in two
 * places.
 */
import { Hero } from '../sections/Hero'
import { Pillars } from '../sections/Pillars'
import { Showcase } from '../sections/Showcase'
import { CompanyStrip } from '../sections/CompanyStrip'
import { Closing } from '../sections/Closing'

export function HomePage() {
  return (
    <>
      <Hero />
      <Pillars />
      <Showcase />
      <CompanyStrip />
      <Closing />
    </>
  )
}
